import { useMutation, useQueryClient } from "@tanstack/vue-query";
import ProjectsApi from "@/common/http/ProjectsApi";
import { onSettled } from "./onSettled";

export const mutationKey = ["delete-recommendation-feedbacks"];

export const useDeleteRecommendationFeedbacks = (props = {}) => {
  const queryClient = useQueryClient();

  const { mutate, ...mutationRest } = useMutation({
    mutationFn: ProjectsApi.deleteRecommendationFeedbacks,
    mutationKey,
    onSettled: onSettled({ queryClient }),
    ...props,
  });

  return {
    deleteRecommendationFeedbacks: mutate,
    ...mutationRest,
  };
}
